import { UserManagerSettings, WebStorageStateStore } from "oidc-client-ts";

export function getOidcSettings(): UserManagerSettings {
  return {
    authority: process.env.VUE_APP_OIDC_AUTHORITY || "",
    client_id: process.env.VUE_APP_OIDC_CLIENT_ID || "",
    redirect_uri:
      process.env.VUE_APP_OIDC_REDIRECT_URI ||
      window.location.origin + "/oidc/callback",
    silent_redirect_uri:
      process.env.VUE_APP_OIDC_SILENT_REDIRECT_URI ||
      window.location.origin + "/oidc/silent-renew.html",
    post_logout_redirect_uri:
      process.env.VUE_APP_OIDC_POST_LOGOUT_REDIRECT_URI ||
      window.location.origin + "/#/sign-in",
    response_type: "code",
    scope: process.env.VUE_APP_OIDC_SCOPE || "openid profile email offline_access urn:zitadel:iam:user:resourceowner",
    automaticSilentRenew: true,
    userStore: new WebStorageStateStore({ store: window.sessionStorage }),
  };
}

export function isOidcConfigured(): boolean {
  return !!(
    process.env.VUE_APP_OIDC_AUTHORITY && process.env.VUE_APP_OIDC_CLIENT_ID
  );
}
